import React, { ReactElement } from 'react';

const DashboardPage = (): ReactElement => <h2>Dashboard</h2>;

export { DashboardPage };
